import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    NgZone,
    Output,
    Renderer2,
    ViewChild,
} from '@angular/core';
import { Subscription } from 'rxjs';

import { TranslationKeyMap } from '../../coaching-insight.i18n';
import { DimensionData } from '../elastic-element.directive';
import { Opportunity } from '../models/oa.model';
import { ElasticUIService } from '../services/elastic-ui.service';
import { TeamOAService } from '../services/team-oa.service';

const pad = 30;

// maintain a list of Team Member Metrics
@Component({
    selector: 'metric-list',
    templateUrl: './metric-list.component.html',
    // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MetricListComponent {
    @Input() metrics: Opportunity[];
    @Input() dimensionIndex: number;

    @Output() clicked: EventEmitter<Opportunity> =
        new EventEmitter<Opportunity>();

    @Output() viewInit: EventEmitter<boolean> = new EventEmitter<boolean>();

    @ViewChild('showBtn', { static: true }) showBtn: any;
    @ViewChild('visibleLinks', { static: true }) visibleLinksContainer: any;
    @ViewChild('visibleLinks', { static: true }) visibleLinks: ElementRef;
    @ViewChild('hiddenLinks', { static: true }) hiddenLinks: ElementRef;

    btnwidth: number;
    allowFluidResize: boolean = false;
    fluidBreakThreshold: number = null;
    allHiddenButtons = false;

    showHiddenButtons: boolean = false;
    showMoreButton: boolean = false;
    destroyedComponent = false;

    public breaks = [];
    listener: any;

    dimensionsub: Subscription;

    i18n = TranslationKeyMap;

    // @HostBinding("class.fluid") allowFluidResize = false;
    // @HostBinding("class.fill") showMoreButton = false;

    constructor(
        protected _teamOAService: TeamOAService,
        // protected _cd: ChangeDetectorRef,
        protected _renderer: Renderer2,
        protected _el: ElementRef,
        protected _elasticService: ElasticUIService,
        protected _ngZone: NgZone,
    ) {}

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    ngOnInit() {
        if (this.destroyedComponent) {
            // this._cd.reattach();
        }
        this.destroyedComponent = false;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    ngAfterViewInit() {
        this.btnwidth =
            this.showBtn.nativeElement.getBoundingClientRect().width;
        this.dimensionsub = this._elasticService.elasticElements.subscribe(
            (d: DimensionData[]) => {
                if (d) {
                    const x = d.find(
                        (g: DimensionData) => g.index === this.dimensionIndex,
                    );
                    if (x) {
                        this.update(x.dimensions);
                    }
                }
            },
        );
        // this.dimensionsub = this._elasticService
        //     .getElasticElementObservable(this.dimensionIndex)
        //     .subscribe(f => {
        //         if (f) {
        //             this.update(f.dimensions);
        //         }
        //     });

        this.viewInit.emit(true);
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    onClick(opp: Opportunity) {
        this.clicked.emit(opp);
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    toggleHiddenButtons(force: boolean = null) {
        this.showHiddenButtons =
            force !== null ? force : !this.showHiddenButtons;

        const g: HTMLElement = this.hiddenLinks.nativeElement;

        if (this.showHiddenButtons === true) {
            let parent: HTMLElement = g;
            try {
                while (parent != null) {
                    if (parent.tagName.toLowerCase() === 'table') {
                        break;
                    }
                    parent = parent.parentElement;
                }
            } catch {
                parent = null;
            }

            const p = parent;
            const gpos = g.getBoundingClientRect();
            const ppos = p?.getBoundingClientRect();
            const pheight = ppos.height;
            const gheight = gpos.height;

            if (
                document.documentElement.scrollTop + ppos.top + pheight <
                document.documentElement.scrollTop + gpos.top + gheight
            ) {
                g.style.setProperty('top', `${-gheight}px`);
            } else {
                g.style.setProperty('top', '100%');
            }
        } else {
            g.style.setProperty('top', '100%');
        }
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    update(dims: any = null) {
        const visiblechildren = this.visibleLinks.nativeElement.children;

        if (!dims) {
            return;
        }

        const containerwidth = dims.width;
        let visiblelinkswidth = this.getVisibleLinksWidth();

        let availableSpace = this.getAvailableSpace(containerwidth);

        // The visible list is overflowing the nav
        if (visiblelinkswidth >= availableSpace) {
            while (
                visiblechildren.length > 1 &&
                visiblelinkswidth >= availableSpace
            ) {
                this.allowFluidResize = false;
                visiblelinkswidth = this._removeButtons(
                    visiblelinkswidth,
                    visiblechildren,
                );

                // if the buttons exceed  container once, show 'more' button
                if (!this.showMoreButton) {
                    // eslint-disable-next-line no-unneeded-ternary
                    this.showMoreButton = this.breaks.length ? true : false;
                    availableSpace = this.getAvailableSpace(containerwidth);
                }

                this.allHiddenButtons = visiblechildren.length === 0;
            }

            // eslint-disable-next-line no-unneeded-ternary
            this.showMoreButton = this.breaks.length ? true : false;
            availableSpace = this.getAvailableSpace(containerwidth);

            if (
                (visiblechildren.length === 1 || !visiblechildren.length) &&
                !this.fluidBreakThreshold
            ) {
                if (visiblelinkswidth > availableSpace) {
                    this.fluidBreakThreshold = parseInt(visiblelinkswidth);
                    this.allowFluidResize = true;
                }
            } else if (this.fluidBreakThreshold) {
                this.allowFluidResize = true;
            }
        } else {
            let xwidth = this.getLastBreak(visiblelinkswidth);
            // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
            const avSpace = availableSpace + pad;

            if (xwidth && avSpace > xwidth) {
                const hiddenchildren = this.hiddenLinks.nativeElement.children;
                if (!hiddenchildren.length) {
                    this.allowFluidResize = true;
                    return;
                } else {
                    // There is space for another item in the nav
                    while (avSpace > xwidth) {
                        this._reAddButtons(hiddenchildren);
                        this.allHiddenButtons = visiblechildren.length === 0;
                        if (!this.breaks.length) {
                            break;
                        }
                        this.allowFluidResize = false;
                        xwidth = this.getLastBreak(visiblelinkswidth);
                    }
                    // compare current space to the last break width
                    if (avSpace < visiblelinkswidth) {
                        this.allowFluidResize = true;
                    }
                }

                // Hide the dropdown btn if hidden list is empty
                if (!this.breaks.length) {
                    this.showHiddenButtons = false;
                    this.allowFluidResize = false;
                    this.fluidBreakThreshold = null;
                }
            } else {
                if (this.fluidBreakThreshold) {
                    // eslint-disable-next-line no-unneeded-ternary
                    this.allowFluidResize =
                        // eslint-disable-next-line no-unneeded-ternary
                        this.fluidBreakThreshold < avSpace ? false : true;
                }
            }
        }

        // eslint-disable-next-line no-unneeded-ternary
        this.showMoreButton = this.breaks.length ? true : false;

        // eslint-disable-next-line @typescript-eslint/dot-notation
        // if (!this._cd['destroyed']) {
        //     this._cd.detectChanges();
        // }
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    getVisibleLinksWidth() {
        return this.visibleLinks.nativeElement.getBoundingClientRect().width;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    getAvailableSpace(containerwidth) {
        return !this.showMoreButton
            ? containerwidth
            : containerwidth - this.btnwidth - pad;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    getLastBreak(visiblelinkswidth) {
        // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
        const x = this.breaks[this.breaks.length - 1] + pad;
        return visiblelinkswidth > x ? visiblelinkswidth : x;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    _removeButtons(width, children) {
        // Record the current width of the list
        this.breaks.push(width);

        // Move item to the hidden list
        // this._renderer.appendChild(this.hiddenLinks.nativeElement, children[children.length - 1]);
        this._renderer.insertBefore(
            this.hiddenLinks.nativeElement,
            children[children.length - 1],
            this.hiddenLinks.nativeElement.firstChild,
        );

        return this.getVisibleLinksWidth();
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    _reAddButtons(children) {
        this.breaks.pop();

        // Move the item to the visible list
        this._renderer.appendChild(
            this.visibleLinks.nativeElement,
            children[0],
        );

        this.allowFluidResize = true;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    track_identify(index, item: Opportunity) {
        return item.metricId;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    ngOnDestroy() {
        // this._cd.detach();
        this.destroyedComponent = false;
        if (this.dimensionsub) {
            this.dimensionsub.unsubscribe();
        }
    }
}
